/**
 * Default options
 */
const DEFAULT_OPTIONS = { chars: 4, separator: /\.|\+|@/ };

/**
 * It will validate that parts of a base string is contained in a
 * challenge string
 *
 * @param {String | [String]} base
 * @param {String} challenge
 * @param {Object} options
 */
export default (base, challenge, options = {}) => {
  if (!Array.isArray(base)) {
    base = [base];
  }
  const config = { ...DEFAULT_OPTIONS, ...(options || {}) };
  const parts = base
    .map(b => b.split(config.separator).filter(w => w.length >= config.chars))
    .reduce((x, y) => x.concat(y));
  return new RegExp(parts.join('|'), 'i').test(challenge);
};
